// extracted by mini-css-extract-plugin
export default {"portals_wrapper":"Portals_portals_wrapper__DDXpl","portals_container":"Portals_portals_container__Uf2xG"};